import { topicTags } from "@/mocks/homeData";

export default function TopicsSection() {
  return (
    <section id="topics" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            当前追剧圈最热讨论话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, idx) => (
            <a
              key={tag.id}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                idx < 3
                  ? "bg-primary-50 border-primary-200/60 text-primary-700 hover:bg-primary-100"
                  : "bg-background-100 border-background-200/60 text-foreground-700 hover:border-primary-200/60 hover:text-primary-600"
              }`}
            >
              <span className="text-sm font-medium">{tag.name}</span>
              <span
                className={`text-[11px] ${
                  idx < 3 ? "text-primary-500" : "text-foreground-500"
                }`}
              >
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}